import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import ChapterRoleAssignLayer from "../components/ChapterRoleAssignLayer";

const ChapterRoleAssignPage = () => {
  return (
    <MasterLayout>
      <ChapterRoleAssignLayer />
    </MasterLayout>
  );
};

export default ChapterRoleAssignPage;
